import React, { useState, useContext } from "react";
import { useParams } from "react-router";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  CloseButton,
  Center,
  Divider,
  Flex,
  Spinner,
  Tag,
  Text,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import { useMutation, useQuery } from "@apollo/client";
import { NEW_CONSULTATION_PRODUCT } from "../../services/graphql/mutation/ConsultationProduct";
import { CONSULTATION_PRODUCTS } from "../../services/graphql/query/ConsultationProduct";
import { ContextApp } from "../../shared/ContextApp";
import { PRODUCT } from "../../services/graphql/query/Product";
import { ModalLogin } from "../ModalLogin/ModalLogin";
import { IProduct } from "../../services/graphql/Product";
import { IConsultationProduct } from "../../services/graphql/ConsultationProduct";

export const Consultation = (props: any) => {
  const { user } = useContext(ContextApp);
  const { id } = useParams();
  const [dataProduct, setDataProduct] = useState<IProduct>();
  const [message, setMessage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [arrayConsultations, setArrayConsultations] = useState<
    IConsultationProduct[]
  >([]);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const [newConsultation] = useMutation(NEW_CONSULTATION_PRODUCT);

  let handleInputChange = (e: any) => {
    let inputValue = e.target.value;
    setMessage(inputValue);
  };

  useQuery(PRODUCT, {
    variables: { filter: { id: Number(id) } },
    onCompleted: (data) => {
      const { product } = data;
      setDataProduct(product);
      setLoading(false);
    },
    onError: (error) => {
      setLoading(false);
    },
  });

  const { fetchMore } = useQuery(CONSULTATION_PRODUCTS, {
    variables: {
      filter: {
        product_id: dataProduct?.id,
      },
    },
    onCompleted: (data) => {
      const { consultation_products_public } = data;
      setArrayConsultations(consultation_products_public);
      setLoading(false);
    },
    onError: (error) => {
      setLoading(false);
    },
  });

  const consultationOnClick = () => {
    if (!user) {
      setIsOpen(true);
    } else {
      setLoading(true);
      newConsultation({
        variables: {
          input: {
            message: message,
            product_id: dataProduct?.id,
            // user_id: user?.id,
          },
        },
      })
        .then(() => {
          toast({
            duration: 2500,
            position: "top",
            render: () => consultationSuccess(),
          });
          fetchMore({
            variables: {
              filter: {
                product_id: dataProduct?.id,
              },
            },
          })
            .then((dataConsultation) => {
              const { data } = dataConsultation;
              const { consultation_products_public } = data;
              setArrayConsultations(consultation_products_public);
              setLoading(false);
            })
            .catch(() => {
              setLoading(false);
            });
        })
        .catch(() => {
          toast({
            duration: 2500,
            position: "top",
            render: () => consultationError(),
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const consultationSuccess = () => (
    <>
      <Alert
        status="success"
        variant="solid"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        height="150px"
      >
        <AlertIcon boxSize="38px" mr={0} />

        <AlertDescription display="block">
          Se ha enviado su consulta!
        </AlertDescription>
      </Alert>
    </>
  );

  const consultationError = () => (
    <>
      <Alert status="error" variant="solid">
        <AlertIcon />
        <Box flex="1">
          <AlertTitle>Ups!</AlertTitle>
          <AlertDescription display="block">
            Se produjo un error al emitir la consulta.
          </AlertDescription>
        </Box>
        <CloseButton position="absolute" right="8px" top="8px" />
      </Alert>
    </>
  );

  return (
    <>
      {loading ? (
        <Center mt={"50px"}>
          <Spinner />
        </Center>
      ) : (
        <>
          <Flex
            mt="50px"
            alignItems="center"
            justifyContent="center"
            direction="column"
            w="80%"
            mx="auto"
          >
            <Text mb="20px" fontSize="xl" as="b">
              Consulta sobre el producto:
            </Text>
            <Box
              w="100%"
              display="flex"
              alignItems="center"
              flexDirection={{ base: "column", sm: "row" }}
            >
              <Textarea
                w={{ base: "100%", sm: "70%" }}
                mr={{ base: "0px", sm: "10px" }}
                mb={{ base: "10px", sm: "0px" }}
                borderRadius="md"
                value={message}
                onChange={handleInputChange}
                placeholder="Escribí tu pregunta:"
                size="sm"
                resize="none"
              />
              <Button
                w={{ base: "100%", sm: "20%" }}
                h="50px"
                size="md"
                onClick={consultationOnClick}
              >
                Preguntar
              </Button>
            </Box>
          </Flex>

          {arrayConsultations.length ? (
            <>
              <Center display={"flex"} flexDirection="column" mt="10px">
                <Text mb="20px" fontSize="xl" as="b">
                  Últimas preguntas
                </Text>
              </Center>
              {arrayConsultations.map((consult) => (
                <>
                  <Flex
                    // m="0 300px"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    my={"10px"}
                  >
                    <Text>
                      {consult.message} - {consult.user.firstname}
                    </Text>
                    {consult.response ? (
                      <Text color="gray.500" as="cite">
                        {consult.response} - Administrador
                      </Text>
                    ) : (
                      <Text color="gray.500" as="cite">
                        *Sin responder*
                      </Text>
                    )}
                  </Flex>
                  <Divider />
                </>
              ))}
            </>
          ) : (
            <>
              <Center display={"flex"} flexDirection="column" mt="10px">
                <p>
                  <Tag>
                    El producto no tiene comentarios. Se el primero en consultar
                  </Tag>
                </p>
              </Center>
            </>
          )}
        </>
      )}

      <ModalLogin
        onClose={() => {
          setIsOpen(false);
        }}
        isOpen={isOpen}
      />
    </>
  );
};
